import { TOSType } from '../../../types/layout';

export function getDeviceTypeFromUserAgent(userAgent: string): TOSType {
  if (/iPad/i.test(userAgent) || /iPhone/i.test(userAgent)) {
    return 'ios';
  } else if (/Android/i.test(userAgent)) {
    return 'android';
  } else {
    return 'other';
  }
}
